const forms = document.querySelectorAll(".quantity-verification");

forms.forEach((form) => {
  const intergerInputs = form.querySelectorAll("input[type=number]");
  const submitBtn = form.querySelector("#submit");

  submitBtn.addEventListener("click", (e) => {
    if (checkForValue(intergerInputs) === 0) {
      e.preventDefault();
      alert("Es muss mindestens ein Produkt bestellt werden.");
    }
  });
});

function checkForValue(elements) {
  let inputsWithQuantity = 0;
  elements.forEach((elm) => {
    if (elm.value > 0) {
      inputsWithQuantity++;
    } else {
      return;
    }
  });
  return inputsWithQuantity;
}
